import {
  getWFHSuccess,
  getWFHError,
  togglePageLoader,
  getWFHsummarySuccess,
  getWFHsummaryError,
  exportWFHDataSuccess,
  exportWFHDataError,
} from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"
// Login Redux States
import {
  getDetailedWorkFromHome,
  getSummaryWorkFromHome,
} from "helpers/backend_helper"

import { GET_DETAILED_WFH_DATA, GET_SUMMARY_WFH_DATA } from "./actionType"

import { EXPORT_DETAILED_WFH_DATA } from "./actionType"
import { exportDetailedWorkFromHomeReport } from "helpers/backend_helper"

//get detailed work from home
function* getdetailedworkfromhome({ payload }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getDetailedWorkFromHome, payload)
    if (response) {
      yield put(getWFHSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWFHError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

//get  summary work from home
function* getsummaryworkfromhome({ payload }) {
  debugger
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getSummaryWorkFromHome, payload)
    if (response) {
      yield put(getWFHSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getWFHsummaryError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* workfromhome() {
  yield takeEvery(GET_DETAILED_WFH_DATA, getdetailedworkfromhome)
  yield takeEvery(GET_SUMMARY_WFH_DATA, getsummaryworkfromhome)
  yield takeEvery(EXPORT_DETAILED_WFH_DATA, exportDetailedWFHSaga)
}

function* exportDetailedWFHSaga({ payload: params, exports,exportname }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(exportDetailedWorkFromHomeReport, params, exportname)
    if (exports !== "export") {
      if (response.statusCode === 200) {
        yield put(getHoursReportSuccess(response))
        yield put(togglePageLoader(false))
      } else {
        yield put(getHoursReportError(response))
        toast.error(response.message)
        yield put(togglePageLoader(false))
      }
    } else {
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getHoursReportError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

export default workfromhome
